import { useConfigStore } from './store/store'
import { setToken } from '~/store/cookies'
import { ViteSSG } from 'vite-ssg'
import { setupLayouts } from 'virtual:generated-layouts'
import App from './App.vue'
import type { UserModule } from './types'
import generatedRoutes from '~pages'
import { vLoading } from 'element-plus'
import 'uno.css'
import 'element-plus/theme-chalk/el-loading.css'
import { getUrlAllParams } from '~/assets/utils'
import '~/assets/http'
import './styles/main.css'
import 'element-plus/dist/index.css'

const routes = setupLayouts(generatedRoutes)

export const createApp = ViteSSG(
  App,
  { routes, base: import.meta.env.BASE_URL },
  (ctx) => {
    Object.values(
      import.meta.glob<{ install: UserModule }>('./modules/*.ts', {
        eager: true
      })
    ).forEach((i) => {
      i.install?.(ctx)
    })
    if (ctx.isClient) {
      ctx.app.directive('loading', vLoading)

      const { router } = ctx

      const configStore = useConfigStore()
      router.beforeEach(async (to, from) => {
        const { path } = to
        const urlParams = getUrlAllParams(to.fullPath)
        configStore.setCurrentPage(path)
        if (urlParams && urlParams['token']) {
          setToken(urlParams['token'])
        }
      })
    }
  }
)
